import posthog from 'posthog-js'

let inited = false

function getEnvironment(): string {
  const env = (import.meta.env.VITE_APP_ENV as string | undefined)?.trim()
  if (env) return env
  return import.meta.env.DEV ? 'development' : 'production'
}

export function initAnalytics(): void {
  if (window.location.pathname.startsWith('/auth/') || window.location.search.includes('oobCode=')) return
  const key = (import.meta.env.VITE_POSTHOG_KEY as string | undefined)?.trim()
  if (!key) return

  const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined)?.trim()
  posthog.init(key, {
    api_host: host || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_exceptions: true,
    before_send: event => window.location.pathname.startsWith('/auth/') || window.location.search.includes('oobCode=') ? null : event,
  })
  inited = true
  posthog.register({ environment: getEnvironment() })
}

export function capturePageView(path: string): void {
  if (!inited) return
  posthog.capture('$pageview', { path })
}

export function identifyUser(
  distinctId: string,
  traits?: { email?: string; name?: string }
): void {
  if (!inited) return
  posthog.identify(distinctId, traits)
}

export function registerSuperProperties(properties: Record<string, unknown>): void {
  if (!inited) return
  posthog.register(properties)
}
